import { ComponentType as T } from "../../registries/types/propTypes.js";
const b = (s) => {
  var l;
  const g = Array.isArray(s == null ? void 0 : s.highlights_c) ? s == null ? void 0 : s.highlights_c[0] : s == null ? void 0 : s.highlights_c, y = (l = g == null ? void 0 : g.features) == null ? void 0 : l.map((i) => {
    var m, o, h, p, n, c, _;
    return {
      displayTitle: i == null ? void 0 : i.display_title,
      subTitle: i == null ? void 0 : i.sub_title,
      image: {
        url: (h = (o = (m = i == null ? void 0 : i.image) == null ? void 0 : m.images[0]) == null ? void 0 : o.image) == null ? void 0 : h.url,
        viewport: (n = (p = i == null ? void 0 : i.image) == null ? void 0 : p.images[0]) == null ? void 0 : n.viewport,
        altText: (_ = (c = i == null ? void 0 : i.image) == null ? void 0 : c.images[0]) == null ? void 0 : _.alt_text
      }
    };
  });
  return {
    componentType: T.highlights_c,
    features: y
  };
};
export {
  b as default,
  b as transformHighlightsC
};
//# sourceMappingURL=highlightsC-transformer.js.map
